import React, { useState } from 'react'
import NoImage from '../../Assets/Images/Logos/no-image.png'
import { validateRepeatedProduct } from '../../Utils/functions'
import Modal from 'react-bootstrap/Modal'
import './productCard.css'
import { Col } from 'react-bootstrap'
import ProductDetail from '../ProductDetail'
import { useDispatch, useSelector } from 'react-redux'
import { Formatter } from 'Utils/Formatter'

function ProductCard({
  data,
  productsRef,
  parentProduct,
  onProductDetailChange,
}) {
  const cart = useSelector(state => state.cart.cart)
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()
  const [openWithInventario, setOpenWithInventario] = useState(null)

  // CART
  // const cart = useSelector(state => state.cart.cart)

  const handleOpen = inventario => {
    setIsOpen(true)
    setOpenWithInventario(inventario)

    if (!inventario) {
      onProductDetailChange?.(data)
    }
  }

  const handleClose = () => {
    setIsOpen(false)
    onProductDetailChange?.(parentProduct)
  }

  return (
    <>
      <Col
        xl={3}
        lg={3}
        md={4}
        sm={6}
        xs={12}
        data-testid="container-product-card-col">
        {data.empty ? (
          <div
            className="product-card-empty"
            data-testid="container-product-card-empty"></div>
        ) : (
          <div
            className="product-carrousel-card"
            data-testid="container-product-card">
            <div
              className="product-carrousel-card-img"
              onClick={() => {
                handleOpen(false)
              }}
              data-testid="btn-open-product-detail">
              <img
                src={data.productImage ? data.productImage : NoImage}
                alt="product-image"
                className="img-fluid"
                data-testid="img-product-card"
              />
            </div>
            <div
              className="product-carrousel-card-generals"
              data-testid="container-product-card-info">
              <p
                className="product-carrousel-card-generals-name"
                data-testid="text-product-card-name">
                {data?.ProductName}
              </p>
              <p
                className="product-carrousel-card-generals-sku"
                data-testid="text-product-card-brand">
                {data.brandName || 'Generico'}
              </p>
              <p
                className="product-carrousel-card-generals-sku"
                data-testid="text-product-card-sku">
                {data.SystemCode}
              </p>
              <p
                className="product-carrousel-card-generals-price"
                data-testid="text-product-card-price">
                {'$' + Formatter.Money(data.FinalPrice)}
              </p>
            </div>
            <div
              className="product-carrousel-card-button"
              data-testid="container-product-card-actions">
              <button
                onClick={() => validateRepeatedProduct(data, cart, dispatch)}
                data-testid="btn-add-product-card">
                Agregar
              </button>
            </div>
          </div>
        )}
      </Col>
      <Modal
        show={isOpen}
        onHide={handleClose}
        container={productsRef ? productsRef.current : null}
        backdrop={false}
        enforceFocus={false}
        autoFocus={false}
        className="modal-clase-producto"
        data-testid="container-product-card-modal">
        <ProductDetail
          id={data.ProductId}
          productsRef={productsRef || null}
          producto_final={data}
          price={data.FinalPrice}
          cost={data.Cost || data.AvgCost || 0.0}
          openWithInventario={openWithInventario}
          handleClose={handleClose}
          onRelatedProductDetailChange={onProductDetailChange}
        />
      </Modal>
    </>
  )
}

export default ProductCard
